import { render, staticRenderFns } from "./ConsultaView.vue?vue&type=template&id=5b3e5665&scoped=true&"
import script from "./ConsultaView.vue?vue&type=script&lang=js&"
export * from "./ConsultaView.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaView.vue?vue&type=style&index=0&id=5b3e5665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e5665",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VDivider,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VProgressCircular,
  VSpacer,
})
